import React, { useEffect } from 'react';

import ApiError from 'common/components/apiError/APIError';
import WidgetAPIError from 'common/components/apiError/WidgetAPIError';
import { useComponentWillMount } from 'common/helpers/hooks';

const WidgetWrapper = (props) => {
  const { children, error, isLoaded, node } = props;

  useComponentWillMount(() => {
    node.style.minHeight = '50vh';
  });

  useEffect(() => {
    if (isLoaded || error) {
      node.style.minHeight = '0';
    }
  }, [node, isLoaded, error]);

  return (
    <>
      <ApiError />
      <WidgetAPIError error={error} />
      {children}
    </>
  );
};

export default WidgetWrapper;
